module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundBigH.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundBigH.svg
// module id = 253
// module chunks = 0